<div class="sso-verify-account"
     [formGroup]="form">

  <div class="ez-alert info">
    <mat-icon color="primary">info</mat-icon>
    <div class="alert-text">
      Please verify your EZLynx Account to Authorize {{ ssoName }} SSO.
    </div>
  </div>

  <mat-form-field id="username"
                  appearance="outline">
    <mat-label>Username</mat-label>

    <input matInput
           type="text"
           id="username-input"
           autocomplete="username"
           formControlName="username"
           autofocus
           required
           name="Username">
    <mat-error>
      Username is required
    </mat-error>
  </mat-form-field>

  <mat-form-field id="password"
                  appearance="outline">
    <mat-label>Password</mat-label>

    <input matInput
           type="password"
           id="password-input"
           autocomplete="current-password"
           formControlName="password"
           name="Password"
           required>
    <mat-error>
      Password is required
    </mat-error>
  </mat-form-field>

  @if (isBadLoginAttempt) {
    <div class="ez-alert warn">
      <mat-icon color="warn">report</mat-icon>
      <span class="alert-text">The login attempt failed. The credentials entered are invalid.</span>
    </div>
  }

  <div class="actions">
    @if (supportLink) {
      <a class="support-link"
         target="blank"
         [href]="supportLink">
        SSO Help
        <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
      </a>
    } @else {
      <span></span>
    }

    <button mat-flat-button
            type="submit"
            color="primary">Verify account</button>
  </div>
</div>
